import { motion, useReducedMotion } from 'motion/react';
import { Sparkle, ArrowRight } from '@phosphor-icons/react';

export function AnnouncementBar() {
  const reduce = useReducedMotion();

  return (
    <a
      href="/app"
      className="group relative flex items-center justify-center gap-2 overflow-hidden bg-indigo-600 px-4 py-2.5 text-center text-sm font-medium text-white"
    >
      <motion.div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'linear-gradient(90deg, transparent 0%, transparent 42%, rgba(255,255,255,0.22) 50%, transparent 58%, transparent 100%)',
        }}
        animate={reduce ? undefined : { x: ['-100%', '100%'] }}
        transition={reduce ? undefined : { duration: 3, repeat: Infinity, ease: 'easeInOut', repeatDelay: 1.5 }}
      />
      <span className="relative flex flex-wrap items-center justify-center gap-2">
        <Sparkle weight="fill" className="h-4 w-4 text-indigo-200" />
        Free during beta. No credit card required.
        <span className="inline-flex items-center gap-1 font-semibold underline-offset-2 group-hover:underline">
          Get started
          <ArrowRight weight="bold" className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
        </span>
      </span>
    </a>
  );
}
